import React from 'react';
import { Card } from '@/components/ui/card';
import { CommunityScopeSelector } from '@/components/admin/CommunityScopeSelector';
import { useCommunityScope } from '@/hooks/useCommunityScope';
import { useAuth } from '@/contexts/AuthContext';

export const UserCommunityScopeBar: React.FC = () => {
  const { currentUser } = useAuth();
  const {
    availableCommunities,
    selectedCommunityId,
    setSelectedCommunityId,
    isGlobalAdmin,
    canChangeCommunity,
    activeMembershipProfile,
  } = useCommunityScope();

  const roleLabelByCommunity: Record<string, string> = {
    manager: 'Administrador',
    president: 'Presidente',
    vocal: 'Vocal',
    neighbor: 'Propietario',
    renter: 'Inquilino',
  };
  const roleLabel = activeMembershipProfile?.role
    ? (roleLabelByCommunity[activeMembershipProfile.role] ?? activeMembershipProfile.role)
    : 'sin rol';
  const showHousing = activeMembershipProfile?.role !== 'manager';

  if (currentUser?.role === 'admin' || isGlobalAdmin || availableCommunities.length <= 1) {
    return null;
  }

  return (
    <Card className="p-4">
      <CommunityScopeSelector
        communities={availableCommunities}
        value={selectedCommunityId ? [selectedCommunityId] : []}
        onChange={(ids) => {
          const next = ids[0] ?? null;
          if (next) setSelectedCommunityId(next);
        }}
        label="Comunidad seleccionada"
        placeholder="Selecciona la comunidad"
        disabled={!canChangeCommunity}
        singleSelect
      />
          {activeMembershipProfile ? (
        <p className="mt-3 text-xs text-muted-foreground">
          Rol en comunidad: <span className="font-medium">{roleLabel}</span>
          {showHousing
            ? <> {' · '}Vivienda: {activeMembershipProfile.block ?? '-'} / {activeMembershipProfile.floor ?? '-'} / {activeMembershipProfile.letter ?? '-' }</>
            : null}
        </p>
      ) : null}
    </Card>
  );
};
